// extracted by mini-css-extract-plugin
module.exports = {"collaborators":"Styles_collaborators__Rv1_I","collaborators--fluid":"Styles_collaborators--fluid__RwExt"};